import { isNonNullable } from '@ori/ts-utils';
import { Image } from "./Image";
import { Deal, IconButtonWrapper, ImageBoxRoot, ImageWrapper, Ppa } from "./styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImageBox = function ImageBox(_ref) {
  var buttons = _ref.buttons,
    labels = _ref.labels,
    productCode = _ref.productCode,
    productImageUrls = _ref.productImageUrls;
  var _ref2 = buttons !== null && buttons !== void 0 ? buttons : {},
    iconButton = _ref2.iconButton;
  var _ref3 = labels !== null && labels !== void 0 ? labels : {},
    deal = _ref3.deal,
    ppa = _ref3.ppa;
  return /*#__PURE__*/_jsxs(ImageBoxRoot, {
    children: [/*#__PURE__*/_jsxs(ImageWrapper, {
      children: [/*#__PURE__*/_jsx(Image, {
        productImageUrls: productImageUrls
      }), /*#__PURE__*/_jsx(Ppa, {
        label: ppa === null || ppa === void 0 ? void 0 : ppa.title,
        type: ppa === null || ppa === void 0 ? void 0 : ppa.labelKey,
        productCode: productCode,
        size: "small"
      })]
    }), /*#__PURE__*/_jsx(Deal, {
      label: deal === null || deal === void 0 ? void 0 : deal.title,
      type: deal === null || deal === void 0 ? void 0 : deal.labelKey,
      productCode: productCode
    }), isNonNullable(iconButton) ? /*#__PURE__*/_jsx(IconButtonWrapper, {
      children: iconButton
    }) : null]
  });
};
//# sourceMappingURL=ImageBox.js.map